<router-outlet />

@if (showSessionWarning) {
  <div class="fixed inset-0 z-[120] flex items-center justify-center bg-slate-900/55 px-4">
    <div
      class="w-full max-w-md rounded-none border border-amber-200 bg-white p-6 shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-label="Alerte expiration de session"
    >
      <h2 class="text-lg font-semibold text-slate-900">Session bientot expiree</h2>
      <p class="mt-3 text-sm text-slate-600">
        Votre session va expirer dans
        <span class="font-semibold text-amber-700">{{ sessionWarningSecondsLeft }}</span>
        seconde(s).
      </p>
      <div class="mt-5 flex justify-end gap-3">
        <button
          type="button"
          class="h-10 rounded-none border border-slate-300 px-4 text-sm font-medium text-slate-700"
          (click)="seDeconnecterMaintenant()"
        >
          Se deconnecter
        </button>
        <button
          type="button"
          class="h-10 rounded-none bg-emerald-600 px-4 text-sm font-semibold text-white"
          (click)="prolongerSession()"
        >
          Prolonger
        </button>
      </div>
    </div>
  </div>
}
